import {observer} from "mobx-react";
import {isObservable, makeAutoObservable} from "mobx";

export abstract class MobxUtils {
  static observer(o: any) {
    if (typeof window !== 'undefined') {
      return observer(o);
    } else {
      return o;
    }
  }

  static makeObservable(target: any) {
    if (isObservable(target)) {
      return target;
    }
    try {
      return makeAutoObservable(target);
    } catch (e) {
      return target;
    }
  }
}